import { InputLabel } from "@material-ui/core";
import { DPButton } from "Components/DP/index";
import React, { FC } from "react";
import { ButtonProps } from "@material-ui/core/Button";

interface Props extends ButtonProps {
  accept?: string;
  multiple?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (evt: any) => void;
}

const DPFileUpload: FC<Props> = props => {
  const { accept, id, multiple, disabled, onChange } = props;
  const newProps = { ...props };
  // don't leak props to button that are meant only for input
  delete newProps.id;
  delete newProps.accept;
  delete newProps.multiple;
  delete newProps.onChange;

  const onClickHandler = (event: React.MouseEvent) => {
    const target = event.target as HTMLInputElement;
    target.value = "";
  };
  return (
    <InputLabel htmlFor={id} style={{ display: "inline" }}>
      <DPButton component="span" {...newProps} />
      <input
        onClick={onClickHandler}
        id={id}
        type="file"
        disabled={disabled}
        accept={accept}
        multiple={multiple}
        onChange={onChange}
        style={{ display: "none" }}
      />
    </InputLabel>
  );
};

export default DPFileUpload;
